import auth from '@/router/auth'
import BlogIndex from '@/components/pages/Index'
import BlogCreate from '@/components/pages/Create'
import BlogUpdate from '@/components/pages/Update'
import BlogShow from '@/components/pages/Show'

export default [
  {
    path: '/pages',
    name: 'pages-index',
    component: BlogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/pages/create',
    name: 'pages-create',
    component: BlogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/pages/update/:id',
    name: 'pages-update',
    component: BlogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/pages/show/:id',
    name: 'pages-show',
    component: BlogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/pages/router.js